export function normalizeUrl(link: string): string {
  return /^https?:\/\//i.test(link) ? link : `https://${link}`;
}

export function domainOf(link: string): string {
  try {
    return new URL(normalizeUrl(link)).hostname.replace(/^www\./, "");
  } catch {
    return link;
  }
}
